import { Fragment } from "react";
import {
  BriefcaseIcon,
  CalendarIcon,
  CheckIcon,
  ChevronDownIcon,
  CurrencyDollarIcon,
  LinkIcon,
  MapPinIcon,
  PencilIcon,
} from "@heroicons/react/20/solid";
import { Menu, Transition } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function CustomerDetails({ 
  email, 
  dateJoined, 
  fullName, 
  org, 
  account_id,
  isAdmin,
  avatarUrl,
  onAvatarChange,
  isUploading
}) {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-6">
        <div className="h-24 w-24 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
          {avatarUrl ? (
            <img 
              src={avatarUrl} 
              alt={fullName} 
              className="h-full w-full object-cover"
            />
          ) : (
            <span className="text-3xl font-bold text-gray-600">
              {fullName?.charAt(0) || "U"}
            </span>
          )}
          
          {isUploading && (
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-white"></div>
            </div>
          )}
        </div>
        
        <div>
          <h1 className="text-3xl font-bold text-gray-900">
            Welcome back, {fullName}
          </h1>
          <p className="text-gray-500 mt-1">{org}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-500">Email</div>
          <div className="text-gray-900 font-medium">{email}</div>
        </div>
        
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-500">Account ID</div>
          <div className="text-gray-900 font-medium">{account_id}</div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-500">Member Since</div>
          <div className="text-gray-900 font-medium">{dateJoined}</div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-500">Organization</div>
          <div className="text-gray-900 font-medium">{org}</div>
        </div>

        
      </div>
    </div>
  );
}
